export default "__VITE_ASSET__Cb_xFb9c__"